var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 38,
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5276 36.4866L2 18.9745M27.5276 36.4866L32.8968 12.8972M27.5276 36.4866L43 10.1895M27.5276 36.4866L13.383 16.5766M2 18.9745L5.06946 7.12634M2 18.9745L13.383 16.5766M32.8968 12.8972L13.383 16.5766M32.8968 12.8972L20.4842 1M32.8968 12.8972L35.5525 1M32.8968 12.8972L43 10.1895M5.06946 7.12634L13.383 16.5766M5.06946 7.12634L20.4842 1M13.383 16.5766L20.4842 1M20.4842 1H35.5525M35.5525 1L43 10.1895",
    stroke: "#1B3B5F",
    strokeWidth: 1.77433
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamong);
export default __webpack_public_path__ + "static/media/diamong.d0057fd6b57a4b29da516898102f2503.svg";
export { ForwardRef as ReactComponent };